export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "asc";
    SortDirection["Descending"] = "desc";
})(SortDirection || (SortDirection = {}));
export function sortDirectionAsQueryParam(sortDirection) {
    return sortDirection === null || sortDirection === void 0 ? void 0 : sortDirection.toUpperCase();
}
